<div class="acadmics">
  <div class="dropdown" #menuDropdown>
    <button type="button" class="programs-toggle dropdown-toggle" id="dropdownMenuButton1" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" data-bs-display="static" aria-expanded="false"
      (click)="menuOpened = true">
      Programs
    </button>

    <div class="dropdown-menu programs-menu" aria-labelledby="dropdownMenuButton1">
      <!-- The menu holds hundreds of elements, so it renders on first open, not on page load -->
      <ng-container *ngIf="menuOpened">

      <!-- ============ DESKTOP / TABLET: sidebar + content ============ -->
      <div class="programs-sidebar d-none d-lg-block">
        <div class="sidebar-group">
          <h6 class="sidebar-group-title" id="programs-offered-heading">Programs Offered</h6>
          <ul class="sidebar-list" role="tablist" aria-labelledby="programs-offered-heading">
            <li *ngFor="let cat of programsOfferedCategories">
              <button type="button" role="tab" class="sidebar-link" [class.active]="activeCategoryId === cat.id"
                [id]="'tab-' + cat.id" [attr.aria-selected]="activeCategoryId === cat.id"
                [attr.aria-controls]="'panel-' + cat.id" (click)="onCategoryClick(cat.id)">
                {{ cat.label }}
              </button>
            </li>
          </ul>
        </div>

        <div class="sidebar-group">
          <h6 class="sidebar-group-title" id="schools-heading">Schools</h6>
          <ul class="sidebar-list" role="tablist" aria-labelledby="schools-heading">
            <li *ngFor="let cat of schoolCategories">
              <a *ngIf="cat.externalHref; else schoolTab" [href]="cat.externalHref" target="_blank"
                rel="noopener noreferrer" class="sidebar-link">
                {{ cat.label }}
              </a>
              <ng-template #schoolTab>
                <button type="button" role="tab" class="sidebar-link" [class.active]="activeCategoryId === cat.id"
                  [id]="'tab-' + cat.id" [attr.aria-selected]="activeCategoryId === cat.id"
                  [attr.aria-controls]="'panel-' + cat.id" (click)="onCategoryClick(cat.id)">
                  {{ cat.label }}
                </button>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>

      <div class="programs-content scroll-sec d-none d-lg-block" *ngIf="activeCategory as cat">
        <div role="tabpanel" [id]="'panel-' + cat.id" [attr.aria-labelledby]="'tab-' + cat.id" tabindex="0"
          class="scroll-box">
          <ng-container *ngTemplateOutlet="programGrid; context: { programs: cat.programs }"></ng-container>
        </div>
      </div>

      <!-- ============ MOBILE: accordion ============ -->
      <div class="programs-accordion d-lg-none">

        <div class="accordion-group-title">Programs Offered</div>

        <div class="accordion-row" *ngFor="let cat of programsOfferedCategories">
          <button type="button" class="accordion-row-toggle" [class.active]="expandedMobileId === cat.id"
            [attr.aria-expanded]="expandedMobileId === cat.id" [attr.aria-controls]="'mob-panel-' + cat.id"
            (click)="toggleMobileCategory(cat.id)">
            <span>{{ cat.label }}</span>
            <app-icon name="chevron-down" class="accordion-chevron" [class.rotated]="expandedMobileId === cat.id"></app-icon>
          </button>

          <div class="accordion-row-body" [id]="'mob-panel-' + cat.id" [class.open]="expandedMobileId === cat.id">
            <div class="accordion-row-body-inner">
              <ng-container *ngIf="expandedMobileId === cat.id">
                <ng-container *ngTemplateOutlet="programGrid; context: { programs: cat.programs }"></ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="accordion-group-title mt-3">Schools</div>

        <div class="accordion-row" *ngFor="let cat of schoolCategories">
          <a *ngIf="cat.externalHref; else schoolAccordionTab" [href]="cat.externalHref" target="_blank"
            rel="noopener noreferrer" class="accordion-row-toggle">
            <span>{{ cat.label }}</span>
          </a>
          <ng-template #schoolAccordionTab>
            <button type="button" class="accordion-row-toggle" [class.active]="expandedMobileId === cat.id"
              [attr.aria-expanded]="expandedMobileId === cat.id" [attr.aria-controls]="'mob-panel-' + cat.id"
              (click)="toggleMobileCategory(cat.id)">
              <span>{{ cat.label }}</span>
              <app-icon name="chevron-down" class="accordion-chevron" [class.rotated]="expandedMobileId === cat.id"></app-icon>
            </button>
          </ng-template>

          <div class="accordion-row-body" [id]="'mob-panel-' + cat.id" [class.open]="expandedMobileId === cat.id">
            <div class="accordion-row-body-inner">
              <ng-container *ngIf="expandedMobileId === cat.id">
                <ng-container *ngTemplateOutlet="programGrid; context: { programs: cat.programs }"></ng-container>
              </ng-container>
            </div>
          </div>
        </div>

      </div>
      </ng-container>

    </div>
  </div>
</div>

<!-- Shared program-card grid, reused by desktop tab panel and mobile accordion -->
<ng-template #programGrid let-programs="programs">
  <div class="row row-cols-2 row-cols-md-3 g-2 g-lg-4">
    <div class="col" *ngFor="let p of programs">
      <div class="program-card" [class.share-active]="p.shareOpen">
        <div class="program-details">
          <div class="d-flex align-items-start justify-content-between">
            <div class="sec-thirdtitle w-auto text-start">
              <h5 class="text-dark">{{ p.title }}</h5>
            </div>
            <app-program-share [title]="p.title" [url]="shareUrl(p)"
              (openChange)="p.shareOpen = $event"></app-program-share>
          </div>
          <div class="d-flex justify-content-between">
            <div class="pro-year">
              <span><i class="material-symbols-outlined" aria-hidden="true">calendar_month</i>{{ p.years }}</span>
              <span><i class="material-symbols-outlined" aria-hidden="true">schedule</i>Full Time</span>
            </div>
          </div>
          <!-- Both buttons on one line, equal width, on every screen -->
          <div class="program-actions d-flex gap-1 gap-lg-2 mt-auto">
            <!-- external programs (IBM on raisoni.net) open in a new tab;
                 our own course pages use the router (no full page reload) -->
            <a *ngIf="isExternal(p.href); else internalReadMore" [href]="p.href" class="cmn-white-button flex-fill"
              target="_blank" rel="noopener noreferrer">
              Read More<span class="visually-hidden"> about {{ p.title }}</span>
            </a>
            <ng-template #internalReadMore>
              <a [routerLink]="p.href" class="cmn-white-button flex-fill"
                (click)="closeMenu()">
                Read More<span class="visually-hidden"> about {{ p.title }}</span>
              </a>
            </ng-template>
            <a [href]="p.applyHref" target="_blank" rel="noopener noreferrer" class="cmn-button flex-fill"
              [attr.aria-label]="'Apply now for ' + p.title">
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
